export default "__VITE_ASSET__ADsPbp$i__";